import React, { useState } from "react";
import { caApi } from "../../../../backend_urls/caApi";
import ReusableForm from "../../../../components/reusable/ReusableForm";
import BaseIcon from "../../../../components/svg_icons/BaseIcon";
import "../../../../css/pages/ca_pages/models/dashboard/QuickActions.css";

const QuickActions = ({ setLoading = false }) => {
    const [formConfig, setFormConfig] = useState(null);

    const handleSubmitAddClient = async (formData) => {
        try {
            setLoading(true);
            await caApi.createClient(formData);
        } catch (e) { console.log(e);
        } finally {
            setFormConfig(null);
            setLoading(false);
        }
    };

    const handleSubmitAddBusiness = async (formData) => {
        try {
            setLoading(true);
            await caApi.createClientBusiness(formData);
        } catch (e) { console.log(e);
        } finally {
            setFormConfig(null);
            setLoading(false);
        }
    };

    const handleCreateDocRequest = () => { console.log("handleCreateDocRequest is pressed"); };
    const handleUploadInvoice = () => { console.log("handleUploadInvoice is pressed"); };

    const actions = [
        {
            id: 1,
            label: "Add Client",
            icon: <BaseIcon name = "user" color="#ffffff" />,
            type: "primary",
            form: {
                title: "Create Client",
                onSubmit: handleSubmitAddClient,
                fields: [
                    { name: "client_name", label: "Client Name", required: true },
                    { name: "email", label: "Email ID", required: true },
                    { name: "phone", label: "Contact Number", required: true },
                ]
            }
        },
        {
            id: 2,
            label: "Add Business",
            icon: <BaseIcon name = "building" color="#ffffff" />,
            type: "primary",
            form: {
                title: "Create Business",
                onSubmit: handleSubmitAddBusiness,
                fields: [
                    { name: "business_name", label: "Business Name", required: true },
                    { name: "business_address", label: "Business Address", required: true },
                    { name: "gstin", label: "GSTIN", required: true },
                    { name: "state_code", label: "State Code", required: true },
                ]
            },
        },
        {
            id: 3,
            label: "Create Doc Request",
            icon: <BaseIcon name = "document" color="#ffffff" />,
            type: "secondary",
            onClick: handleCreateDocRequest,
        },
        {
            id: 4,
            label: "Upload Invoice",
            icon: "📤",
            type: "secondary",
            onClick: handleUploadInvoice,
        },
    ];

    return (
        <>
            <div className = "caDashPro__actionsCard">
                <h3 className = "caDashPro__actionsTitle">
                    Quick Actions
                </h3>

                <div className = "caDashPro__actionsGrid">
                    {actions.map((action) => (
                        <button
                            key = { action.id }
                            className = { `caDashPro__actionBtn ${action.type}` }
                            onClick={() => {
                                if (action.form) { setFormConfig(action.form);
                                } else { action.onClick?.(); }
                            }}
                        >
                            <span className="caDashPro__actionIcon">
                                { action.icon }
                            </span>

                            <span className="caDashPro__actionLabel">
                                { action.label }
                            </span>
                        </button>
                    ))}
                </div>
            </div>

            <ReusableForm
                isOpen={!!formConfig}
                onClose={() => setFormConfig(null)}
                title={formConfig?.title}
                onSubmit={formConfig?.onSubmit}
                fields={formConfig?.fields || []}
            />
        </>
    );
};

export default QuickActions;
